import http from '../http';
import { ticketBase } from '../ipConfig';

export default {
    //  获取活动日历
    getAppointsByActivityId(id){
        return http.get(`${ticketBase}/ticket-api/api/activities/appoints.json`, { params: { activityId: id } })
    },
}